export const getChapterParentId = async (
  chapterId,
  capitulos,
  trobat = false,
  i = 0,
  parentId = "",
) => {
  while (!trobat && i < capitulos.length) {
    if (capitulos[i].chapterId == chapterId) {
      parentId = capitulos[i].parentId
      trobat = true
    } else {
      if (capitulos[i].subcapitulos.length > 0) {
        parentId = await getChapterParentId(
          chapterId,
          capitulos[i].subcapitulos,
          trobat,
          0,
          parentId,
        )
      }
      i++
    }
  }
  return parentId
}
export const getChapterParentId2 = async (
  chapterId,
  capitulos,
  trobat = false,
  i = 0,
  parentId = {},
) => {
  while (!trobat && i < capitulos.length) {
    if (capitulos[i].chapterId == chapterId) {
      parentId = capitulos[i]
      trobat = true
    } else {
      if (capitulos[i].subcapitulos.length > 0) {
        parentId = await getChapterParentId2(
          chapterId,
          capitulos[i].subcapitulos,
          trobat,
          0,
          parentId,
        )
      }
      i++
    }
  }
  return parentId
}
export const getChapterById = async (
  chapterId,
  capitulos,
  trobat = false,
  i = 0,
  chapter = {},
) => {
  while (!trobat && i < capitulos.length) {
    if (capitulos[i].chapterId == chapterId) {
      chapter = capitulos[i]
      trobat = true
    } else {
      if (capitulos[i].subcapitulos.length > 0) {
        chapter = await getChapterById(
          chapterId,
          capitulos[i].subcapitulos,
          trobat,
          0,
          chapter,
        )
      }
      i++
    }
  }

  return chapter
}

export const getChapterByParentAndPosition = async (
  parentId,
  capitulos,
  position,
  trobat = false,
  i = 0,
  chapter = {},
) => {
  while (!trobat && i < capitulos.length) {
    if (capitulos[i].parentId == parentId) {
      if (position == capitulos[i].capituloInfo.position) {
        chapter = capitulos[i]
        trobat = true
      } else {
        i++
      }
    } else {
      if (capitulos[i].subcapitulos.length > 0) {
        chapter = await getChapterByParentAndPosition(
          parentId,
          capitulos[i].subcapitulos,
          position,
          trobat,
          0,
          chapter,
        )
      }
      i++
    }
  }

  return chapter
}

export const swapPartidasPosition = (partida1, partida2) => {
  // Swap the parts
  let temp = partida1.position
  partida1.position = partida2.position
  partida2.position = temp
  return { partida1: partida1, partida2: partida2 }
}

export const getPartByParentAndPosition = async (
  parentId,
  capitulos,
  position,
  trobat = false,
  i = 0,
  chapter = {},
) => {
  while (!trobat && i < capitulos.length) {
    if (capitulos[i].chapterId == parentId) {
      let j = 0
      let trobat2 = false
      while (!trobat2 && j < capitulos[i].partidas.length) {
        if (position == capitulos[i].partidas[j].position) {
          chapter = capitulos[i].partidas[j]
          trobat = true
          trobat2 = true
        } else {
          j++
        }
      }
      i++
    } else {
      if (capitulos[i].subcapitulos.length > 0) {
        chapter = await getPartByParentAndPosition(
          parentId,
          capitulos[i].subcapitulos,
          position,
          trobat,
          0,
          chapter,
        )
      }
      i++
    }
  }

  return chapter
}

export const changesPartidasById = async (
  chapterId,
  capitulos,
  trobat = false,
  i = 0,
  partidas,
) => {
  while (!trobat && i < capitulos.length) {
    if (capitulos[i].chapterId == chapterId) {
      capitulos[i].partidas = partidas
      trobat = true
    } else {
      if (capitulos[i].subcapitulos.length > 0) {
        partidas = await changesPartidasById(
          chapterId,
          capitulos[i].subcapitulos,
          trobat,
          0,
          partidas,
        )
      }
      i++
    }
  }
}

export const getPartIndex = async (chapter, partId) => {
  let i = 0
  let trobat = false
  while (!trobat && i < chapter.partidas.length) {
    if (chapter.partidas[i].partidaId == partId) {
      trobat = true
    } else {
      i++
    }
  }
  return i
}

export const getChapterIndex = async (parentChapter, chapterId) => {
  let i = 0
  let trobat = false
  while (!trobat && i < parentChapter.subcapitulos.length) {
    if (parentChapter.subcapitulos[i].chapterId == chapterId) {
      trobat = true
    } else {
      i++
    }
  }
  return i
}

export const parseDecomposition = parts => {
  if (parts[i].desglose) {
    Object.keys(parts[i].desglose).forEach(key => {
      decomposition.push({
        description: parts[i].desglose[key]["RESUMEN"],
        quantity: parseFloat(
          parseFloat(parts[i].desglose[key]["RENDIMIENTO"]).toFixed(2),
        ),
        price: parseFloat(
          parseFloat(parts[i].desglose[key]["PRECIO"]["E"]).toFixed(2),
        ),
        type: parseInt(parts[i].desglose[key]["TIPO"]) > 1 ? 0 : 1,
        unity: parts[i].desglose[key]["UNIDAD"],
      })
    })
  }
}

export const getPreviousPartByParentAndPosition = async (
  parentId,
  capitulos,
  position,
  trobat = false,
  i = 0,
  chapter = {},
) => {
  while (!trobat && i < capitulos.length) {
    if (capitulos[i].chapterId == parentId) {
      let j = 0
      let trobat2 = false
      while (!trobat2 && j < capitulos[i].partidas.length) {
        if (position == capitulos[i].partidas[j].position) {
          chapter = capitulos[i].partidas[j - 1]
          trobat = true
          trobat2 = true
        } else {
          j++
        }
      }
      i++
    } else {
      if (capitulos[i].subcapitulos.length > 0) {
        chapter = await getPreviousPartByParentAndPosition(
          parentId,
          capitulos[i].subcapitulos,
          position,
          trobat,
          0,
          chapter,
        )
      }
      i++
    }
  }

  return chapter
}

export const getNextPartByParentAndPosition = async (
  parentId,
  capitulos,
  position,
  trobat = false,
  i = 0,
  chapter = {},
) => {
  while (!trobat && i < capitulos.length) {
    if (capitulos[i].chapterId == parentId) {
      let j = 0
      let trobat2 = false
      while (!trobat2 && j < capitulos[i].partidas.length) {
        if (position == capitulos[i].partidas[j].position) {
          chapter = capitulos[i].partidas[j + 1]
          trobat = true
          trobat2 = true
        } else {
          j++
        }
      }
      i++
    } else {
      if (capitulos[i].subcapitulos.length > 0) {
        chapter = await getNextPartByParentAndPosition(
          parentId,
          capitulos[i].subcapitulos,
          position,
          trobat,
          0,
          chapter,
        )
      }
      i++
    }
  }

  return chapter
}

export const roundToDecimals = (value, decimals) => {
  if (value === null || value === undefined || isNaN(Number(value))) {
    return 0
  }
  const factor = Math.pow(10, decimals)
  return Math.round(Number(value) * factor) / factor
}

const chapterDisplayName = capitulo =>
  capitulo?.capituloInfo?.name ?? capitulo?.name ?? ""

export const partidaMatchesSearch = (partida, queryLower) => {
  const info = partida?.partidaInfo ?? partida ?? {}
  const blob = [info.name, info.description, info.code]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
  return blob.includes(queryLower)
}

export const isChapterVisibleInSearch = (capitulo, queryTrimmed) => {
  if (!queryTrimmed) return true
  const q = queryTrimmed.toLowerCase()
  if (chapterDisplayName(capitulo).toLowerCase().includes(q)) return true
  if ((capitulo.partidas || []).some(p => partidaMatchesSearch(p, q)))
    return true
  if (
    (capitulo.subcapitulos || []).some(sub =>
      isChapterVisibleInSearch(sub, queryTrimmed),
    )
  )
    return true
  return false
}

export const getPartidasForSearchDisplay = (capitulo, queryTrimmed) => {
  if (!queryTrimmed) return capitulo.partidas || []
  const q = queryTrimmed.toLowerCase()
  if (chapterDisplayName(capitulo).toLowerCase().includes(q))
    return capitulo.partidas || []
  return (capitulo.partidas || []).filter(p => partidaMatchesSearch(p, q))
}

export const getSubcapitulosForSearchDisplay = (capitulo, queryTrimmed) => {
  if (!queryTrimmed) return capitulo.subcapitulos || []
  return (capitulo.subcapitulos || []).filter(sub =>
    isChapterVisibleInSearch(sub, queryTrimmed),
  )
}

export const countSelectedInTree = subcapitulos => {
  let chapters = 0
  let parts = 0

  const traverse = caps => {
    for (const cap of caps) {
      if (cap.checked) chapters++
      for (const part of cap.partidas || []) {
        if (part.checked) parts++
      }
      if (cap.subcapitulos && cap.subcapitulos.length > 0) {
        traverse(cap.subcapitulos)
      }
    }
  }

  traverse(subcapitulos || [])
  return { chapters, parts }
}

export const getChapterCheckState = chapter => {
  const leaves = []

  const collectLeaves = cap => {
    if (
      (!cap.subcapitulos || cap.subcapitulos.length === 0) &&
      (!cap.partidas || cap.partidas.length === 0)
    ) {
      leaves.push({ checked: cap.checked })
      return
    }
    for (const part of cap.partidas || []) {
      leaves.push({ checked: part.checked })
    }
    for (const sub of cap.subcapitulos || []) {
      collectLeaves(sub)
    }
  }

  collectLeaves(chapter)

  if (leaves.length === 0) return chapter.checked ? "all" : "none"

  const checkedCount = leaves.filter(l => l.checked).length
  if (checkedCount === 0) return "none"
  if (checkedCount === leaves.length) return "all"
  return "some"
}
